<template>
  <modal
    name="alert-modal"
    class="AppModalAlerts"
    :width="width"
    height="auto"
    :adaptive="true"
    :reset="false"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    @opened="opened"
    @closed="closed"
  >
    <div class="AppModalAlerts__container">
      <app-loader
        class="AppModalAlerts__loader"
        isCircle
        v-if="isLoading"
      ></app-loader>
      <button
        v-if="isButton"
        class="AppModalAlerts__close"
        aria-label="close"
        type="button"
        @click.prevent="hide"
      ></button>
      <template v-if="isConfirm">
        <div class="AppModalAlerts__content">
          <h3 v-if="title" class="AppModalAlerts__title">{{ title }}</h3>
          <p v-if="text" class="AppModalAlerts__text">{{ text }}</p>
        </div>
        <div class="AppModalAlerts__btn-group">
          <app-button-control
            @click="cancel"
            isUppercase
            class="AppModalAlerts__btn"
          >
            нет
          </app-button-control>
          <app-button-control
            @click="accept"
            class="AppModalAlerts__btn"
            type="secondary"
          >
            да
          </app-button-control>
        </div>
      </template>
      <template v-if="isSberCreditLink">
        <div class="AppModalAlerts__content">
          <p class="AppModalAlerts__sber-text">
            После подтверждения в новой вкладке браузера откроется страница со
            списком ваших заявок на сайте СберБизнеса. Там вы сможете продолжить
            оформление заявки на кредит.
          </p>
          <p class="AppModalAlerts__sber-strong-text">
            Вы уверены, что хотите продолжить?
          </p>
        </div>
        <div class="AppModalAlerts__btn-group">
          <app-button-control
            @click="cancel"
            isUppercase
            class="AppModalAlerts__btn"
          >
            нет
          </app-button-control>
          <app-button-control
            @click="accept"
            class="AppModalAlerts__btn"
            type="secondary"
          >
            да
            <app-svg-icon
              isCurrentColor
              name="blank"
              class="AppModalAlerts__sber-btn-icon"
            ></app-svg-icon>
          </app-button-control>
        </div>
      </template>
      <div v-if="isDone" class="AppModalAlerts__done-content">
        <app-svg-icon
          name="done_modal"
          class="AppModalAlerts__done-icon"
        ></app-svg-icon>
        <h3 v-if="title" class="AppModalAlerts__done-title">{{ title }}</h3>
        <div class="AppModalAlerts__done-bottom">
          <p v-if="text" class="AppModalAlerts__done-text">{{ text }}</p>
          <p v-if="greenText" class="AppModalAlerts__done-text-green">
            {{ greenText }}
          </p>
          <p v-if="greyText" class="AppModalAlerts__done-text-grey">
            {{ greyText }}
          </p>
        </div>
      </div>
      <div v-if="isTextarea" class="AppModalAlerts__textarea">
        <div class="AppModalAlerts__textarea-group">
          <textarea
            class="AppModalAlerts__textarea-input"
            :placeholder="placeholder"
            v-model="value"
          />
          <small v-if="isValueError" class="app-input-group__invalid">
            Введите текст
          </small>
        </div>
        <div class="AppModalAlerts__textarea-btn-group">
          <app-button-control
            @click="cancel"
            isUppercase
            type="border-grey-light"
            class="AppModalAlerts__textarea-btn"
            size="small"
          >
            <span class="AppModalAlerts__btn-close"></span> Отменить
          </app-button-control>
          <app-button-control
            size="small"
            @click="submit"
            class="AppModalAlerts__textarea-btn"
            type="secondary"
          >
            Отправить
          </app-button-control>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { eventBus } from '@/main';

export default {
  name: 'AppModalAlerts',
  components: {
    AppLoader: () => import('@/components/ui/AppLoader'),
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    isLoading: false,
    params: {},
    isInit: false,
    value: '',
    isValueError: false,
  }),
  computed: {
    width() {
      return this.params?.width ? this.params.width : '435';
    },
    eventId() {
      return this.params?.eventId ? this.params.eventId : '';
    },
    isButton() {
      return !!this.isDone;
    },
    isConfirm() {
      return this.params?.isConfirm ? this.params.isConfirm : false;
    },
    isSberCreditLink() {
      return this.params?.isSberCreditLink
        ? this.params.isSberCreditLink
        : false;
    },
    isDone() {
      return this.params?.isDone ? this.params.isDone : false;
    },
    isTextarea() {
      return this.params?.isTextarea ? this.params.isTextarea : false;
    },
    placeholder() {
      return this.params?.placeholder
        ? this.params.placeholder
        : 'Введите текст';
    },
    title() {
      return this.params?.title ? this.params.title : 'Вы уверены что хотите';
    },
    text() {
      return this.params?.text ? this.params.text : '';
    },
    greenText() {
      return this.params?.greenText ? this.params.greenText : '';
    },
    greyText() {
      return this.params?.greyText ? this.params.greyText : '';
    },
  },
  methods: {
    resetData() {
      this.isLoading = false;
      this.params = {};
      this.isInit = false;
      this.value = '';
      this.isValueError = false;
    },
    opened() {
      eventBus.$emit('am-opened', {
        eventId: this.eventId,
      });
    },
    closed(event) {
      eventBus.$emit('am-closed', {
        eventId: this.eventId,
        value: event,
      });
    },
    openModal(params) {
      this.$modal.show('alert-modal', params);
    },
    hide() {
      this.$modal.hide('alert-modal');
      eventBus.$emit('am-hide', {
        eventId: this.eventId,
      });
    },
    beforeOpen(data) {
      this.resetData();
      eventBus.$emit('am-before-open', {
        eventId: this.eventId,
      });
      this.params = data.params;
    },
    beforeClose() {
      eventBus.$emit('am-before-close', {
        eventId: this.eventId,
      });
    },
    cancel() {
      this.$modal.hide('alert-modal');
      eventBus.$emit('am-cancel', {
        eventId: this.eventId,
      });
    },
    accept() {
      this.$modal.hide('alert-modal');
      eventBus.$emit('am-accept', {
        eventId: this.eventId,
        value: this.params?.value || null,
      });
    },
    submit() {
      this.isValueError = false;
      if (this.value.length) {
        this.$modal.hide('alert-modal');
        eventBus.$emit('am-submit', {
          eventId: this.eventId,
          value: this.value,
        });
        return false;
      }
      this.isValueError = true;
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.AppModalAlerts {
  &__container {
    padding: 30px 10px;
  }

  &__loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &__btn-group {
    display: flex;
    justify-content: center;
  }

  &__btn {
    min-width: 160px;
    margin-right: 25px;

    &:last-of-type {
      margin-right: 0;
    }

    @include media-xs {
      min-width: 90px;
      margin-right: 10px;
    }
  }

  &__sber-btn-icon {
    @include size(11.5px);

    margin-left: 5px;
    fill: $white;
  }

  &__content {
    margin-bottom: 30px;
    text-align: center;
  }

  &__title {
    @include h-reset;

    margin-bottom: 18px;
    font-size: rem(18);
    font-weight: 300;
  }

  &__text {
    margin: 0;
    font-size: rem(18);
    font-weight: 300;
  }

  &__sber-text {
    margin: 0;
    font-size: rem(15);
    font-weight: 300;
    line-height: 17px;
  }

  &__sber-strong-text {
    margin: 0;
    margin-top: 25px;
    font-size: rem(15);
    font-weight: normal;
    line-height: 17px;
  }

  &__textarea {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__textarea-group {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 332px;
    margin-bottom: 11px;
  }

  &__textarea-input {
    @include input-reset;

    width: 100%;
    height: 70px;
    padding: 7px 8px;
    border: 1px solid #eee;
    border-radius: 2px;
  }

  &__textarea-btn-group {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    max-width: 332px;
  }

  &__textarea-btn {
    min-width: 118px;
    margin-right: 7px;

    &:last-of-type {
      margin-right: 0;
    }

    @include media-xs {
      min-width: 90px;
      margin-right: 10px;
    }
  }
  // done
  &__done-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;
  }

  &__done-icon {
    width: 148px;
    height: 132px;
    margin-bottom: 22px;
  }

  &__done-title {
    @include h-reset;

    max-width: 344px;
    margin-bottom: 13px;
    font-size: rem(18);
    font-weight: normal;
    line-height: 22px;
    text-align: center;
  }

  &__done-bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: calc(100% + 40px);
    padding: 20px 10px 11px;
    margin-bottom: -40px;
    background: #f3f3f3;
  }

  &__done-text {
    margin: 0;
    font-size: rem(14);
    font-weight: 300;
    line-height: 17px;
    text-align: center;
  }

  &__done-text-green {
    margin: 0;
    font-size: rem(16);
    font-weight: 600;
    line-height: 22px;
    color: $accent;
    text-align: center;
  }

  &__done-text-grey {
    margin: 0;
    margin-top: 11px;
    font-size: rem(9);
    font-weight: 250;
    line-height: 10px;
    color: $black;
    text-align: center;
  }
  //
  &__btn-close {
    position: relative;
    width: 9px;
    height: 9px;
    padding: 0;
    margin-right: 9px;
    cursor: pointer;
    background-color: $color-transparent;
    border: 0;

    &::before,
    &::after {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 11px;
      height: 1px;
      content: '';
      background: #acacac;
      transition: background-color $transition-delay;
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &::after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }

  &__close {
    position: absolute;
    top: 11px;
    right: 11px;
    width: 40px;
    height: 40px;
    padding: 0;
    cursor: pointer;
    background-color: $color-transparent;
    border: 0;

    &::before,
    &::after {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 18px;
      height: 2px;
      content: '';
      background-color: $gray-dark;
      transition: background-color $transition-delay;
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &::after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }

    &:hover {
      &::before,
      &::after {
        background-color: $color-brand-green;
      }
    }
  }
}
</style>
